// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__1Vve3","fadeIn":"Spinner_fadeIn__DEVXC"};